/* eslint-disable radix */
/* eslint-disable no-negated-condition */
ACC.merchandiseProduct = {
  merchProductUpdate: function(listname, code, quantity) {
    var url = '/merchandise/updateProductQuantity';

    $.ajax({
      url: ACC.config.encodedContextPath + url,
      data: {
        shoppingListName: listname,
        productCode: code,
        quantity: quantity
      },
      type: 'POST',
      datatype: 'json'
    });
  }
};

$(document).ready(function() {
  var maximqty = 99,
      minimqty = 1,
      btn = 'button',
      disablebtn = 'ph-disable-' + btn,
      qtyplusbutton = '.ph-merch_qtyplus',
      qtyminusbutton = '.ph-merch_qtyminus',
      count = 'count',
      cntStr = '-count',
      list = $('#ph-merchlistnameCheckout').val(),
      merchProdCodeStr = 'ph-merch-prodCode-',
      prodCountPageLoad = $('.ph-merch-new .shopping-row').length,
      merchNewStr = '.ph-merch-new',
      merchNewEmpty = '.ph-merch-empty';

  if (prodCountPageLoad === 0) {
    $(merchNewStr).addClass('hidden');
    $(merchNewEmpty).removeClass('hidden');
  } else {
    $(merchNewStr).removeClass('hidden');
    $(merchNewEmpty).addClass('hidden');
  }

  $(qtyminusbutton).each(function() {
    var qtyCheck = parseInt($('#merchCheckQty-' + $(this).attr('data-' + count)).val());

    if (qtyCheck === minimqty) {
      $(this).addClass(disablebtn);
    } else {
      $(this).removeClass(disablebtn);
    }
  });

  $(qtyplusbutton).each(function() {
    var qtyCheck = parseInt($('#merchCheckQty-' + $(this).attr('data-' + count)).val());

    if (qtyCheck >= maximqty) {
      $(this).addClass(disablebtn);
    } else {
      $(this).removeClass(disablebtn);
    }
  });


  $(document).on('keyup', '.ph-return-qtybox-merch', function() {
    var quantityMerchKey = Number($(this).val());

    if (!quantityMerchKey) {
      quantityMerchKey = 0;
      $(this).val(quantityMerchKey);
    } else {
      $(this).val(quantityMerchKey);
    }
  });

  $(document).on('change', '.ph-return-qtybox-merch', function() {
    var maxQuantityMerch = $(this).attr('max'),
        minQuantityMerch = $(this).attr('min'),
        quantityMerch = Number($(this).val()),
        code = '',
        contentUnit = Number($(this).attr('data-min'));

    if (!quantityMerch) {
      quantityMerch = contentUnit;
      $(this).val(quantityMerch);
    } else {
      quantityMerch = ACC.autocomplete.roundqty(quantityMerch, contentUnit);
      $(this).val(quantityMerch);
    }

    if (parseInt($(this).val()) >= parseInt(maxQuantityMerch)) {
      $(this).siblings(qtyplusbutton).addClass(disablebtn);
      quantityMerch = maxQuantityMerch;
      $(this).val(maxQuantityMerch);
    } else {
      $(this).siblings(qtyplusbutton).removeClass(disablebtn);
    }

    if (parseInt($(this).val()) > parseInt(minQuantityMerch)) {
      $(this).siblings(qtyminusbutton).removeClass(disablebtn);
    } else {
      $(this).siblings(qtyminusbutton).addClass(disablebtn);
    }

    code = $('#' + merchProdCodeStr + $(this).attr('data' + cntStr)).html();

    ACC.merchandiseProduct.merchProductUpdate(list, code, quantityMerch);
  });

  $(document).on('click', '#ph-merch-new .ph-list_plusminus', function() {
    var merch = 'merch',
        selreturnqtyid = '.ph-return-qtybox-' + merch,
        qtyminus = $(this).siblings(selreturnqtyid).val(),
        maxqty = parseInt($(this).siblings(selreturnqtyid).attr('max')),
        minqty = parseInt($(this).siblings(selreturnqtyid).attr('min')),
        contentUnit = Number($(this).attr('data-min')),
        code = '',
        quantity = '';

    if ($(this).hasClass('ph-merch_qtyminus')) {
      if (parseInt(qtyminus) !== contentUnit) {
        $(this).siblings(selreturnqtyid).val(parseInt(qtyminus) - contentUnit);
        quantity = parseInt(qtyminus) - contentUnit;
      }

      $(this).siblings(qtyplusbutton).removeClass(disablebtn);

      if (parseInt(qtyminus) - contentUnit === minqty) {
        $(this).addClass(disablebtn);
      } else {
        $(this).removeClass(disablebtn);
      }
    } else if ($(this).hasClass('ph-merch_qtyplus')) {
      if (parseInt(qtyminus) <= maxqty) {
        $(this).siblings(selreturnqtyid).val(parseInt(qtyminus) + contentUnit);
        quantity = parseInt(qtyminus) + contentUnit;
      }

      $(this).siblings(qtyminusbutton).removeClass(disablebtn);

      if (parseInt(qtyminus) + contentUnit === maxqty) {
        $(this).addClass(disablebtn);
      } else {
        $(this).removeClass(disablebtn);
      }
    }

    code = $('#' + merchProdCodeStr + $(this).attr('data-count')).html();

    ACC.merchandiseProduct.merchProductUpdate(list, code, quantity);
  });

  $(document).on('click', '.ph-merch-pro-delete', function() {
    var quantity = parseInt(0),
        counter = $(this).attr('data-count'),
        prodCount = 0,
        code = $('#' + merchProdCodeStr + counter).html();

    $('.ph-prodindex-' + counter).remove();
    ACC.merchandiseProduct.merchProductUpdate(list, code, quantity);
    prodCount = $('.ph-merch-new .shopping-row').length;

    if (prodCount === 0) {
      $(merchNewStr).addClass('hidden');
      $(merchNewEmpty).removeClass('hidden');
    } else {
      $(merchNewStr).removeClass('hidden');
      $(merchNewEmpty).addClass('hidden');
    }
  });
});

/* eslint-enable radix */
/* eslint-enable no-negated-condition */
